import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import Placeholder from 'components/consumer/Placeholder';
import useFixedWidthContainerSizeProps from 'hooks/useFixedWidthContainerSizeProps';
import MobileAndTabletOnly from 'components/consumer/MobileAndTabletOnly';
import DesktopOnly from 'components/consumer/DesktopOnly';
import PDPInfoTable from '../PDPInfoTable';
import PDPDimensionShotViewer from '../PDPDimensionShotViewer';
const PDPDimensionsContentUI = t0 => {
  const $ = _c(35);
  const {
    dimensionsDesktopImage,
    dimensionsMobileImage,
    dimensions: t1,
    boxDimensions: t2,
    loading: t3,
    onImageClick,
    isSidebarContent: t4,
    hasCylindoDimensionShots: t5,
    dimensionShotUrls: t6,
    currentDimensionShot,
    hasMultipleDimensionShots: t7,
    selectedDimensionShotIndex: t8,
    goToNextDimensionShot,
    goToPreviousDimensionShot
  } = t0;
  let t9;
  if ($[0] !== t1) {
    t9 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const dimensions = t9;
  let t10;
  if ($[2] !== t2) {
    t10 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  const boxDimensions = t10;
  const loading = t3 === undefined ? false : t3;
  const isSidebarContent = t4 === undefined ? false : t4;
  const hasCylindoDimensionShots = t5 === undefined ? false : t5;
  let t11;
  if ($[4] !== t6) {
    t11 = t6 === undefined ? [] : t6;
    $[4] = t6;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const dimensionShotUrls = t11;
  const hasMultipleDimensionShots = t7 === undefined ? false : t7;
  const selectedDimensionShotIndex = t8 === undefined ? 0 : t8;
  const desktopImageFullWidthProps = useFixedWidthContainerSizeProps();
  let t12;
  if ($[6] !== desktopImageFullWidthProps || $[7] !== isSidebarContent) {
    t12 = isSidebarContent ? {
      sizes: "30vw"
    } : desktopImageFullWidthProps;
    $[6] = desktopImageFullWidthProps;
    $[7] = isSidebarContent;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  const desktopImageProps = t12;
  let t13;
  if ($[9] !== loading) {
    t13 = loading && <Placeholder loading={true} type="rect" style={{
      marginRight: 0,
      marginTop: "10px",
      height: "207px"
    }} />;
    $[9] = loading;
    $[10] = t13;
  } else {
    t13 = $[10];
  }
  let t14;
  if ($[11] !== currentDimensionShot || $[12] !== desktopImageProps || $[13] !== dimensionShotUrls || $[14] !== dimensionsDesktopImage || $[15] !== dimensionsMobileImage || $[16] !== goToNextDimensionShot || $[17] !== goToPreviousDimensionShot || $[18] !== hasCylindoDimensionShots || $[19] !== hasMultipleDimensionShots || $[20] !== loading || $[21] !== onImageClick || $[22] !== selectedDimensionShotIndex) {
    t14 = !loading && <><MobileAndTabletOnly>{hasCylindoDimensionShots && currentDimensionShot ? <PDPDimensionShotViewer currentDimensionShot={currentDimensionShot} hasMultipleDimensionShots={hasMultipleDimensionShots} selectedDimensionShotIndex={selectedDimensionShotIndex} totalDimensionShots={dimensionShotUrls.length} onPrevious={goToPreviousDimensionShot} onNext={goToNextDimensionShot} className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden aspect-[1/1]" sizes="100vw" height="900" width="900" /> : dimensionsMobileImage && <JBImage src={dimensionsMobileImage} sizes="100vw" height="900" width="900" className="w-full mt-6 mx-0 mb-4 lg:m-0 lg:hidden" />}</MobileAndTabletOnly><DesktopOnly>{hasCylindoDimensionShots && currentDimensionShot ? <PDPDimensionShotViewer currentDimensionShot={currentDimensionShot} hasMultipleDimensionShots={hasMultipleDimensionShots} selectedDimensionShotIndex={selectedDimensionShotIndex} totalDimensionShots={dimensionShotUrls.length} onPrevious={goToPreviousDimensionShot} onNext={goToNextDimensionShot} className={classNames("w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden aspect-[4/3]", {
          "hover:cursor-target": onImageClick
        })} onClick={onImageClick} {...desktopImageProps} /> : dimensionsDesktopImage && <JBImage src={dimensionsDesktopImage} onClick={onImageClick} {...desktopImageProps} className={classNames("w-full mt-6 mx-0 mb-4 lg:m-0 max-[1023px]:hidden", {
          "hover:cursor-target": onImageClick
        })} />}</DesktopOnly></>;
    $[11] = currentDimensionShot;
    $[12] = desktopImageProps;
    $[13] = dimensionShotUrls;
    $[14] = dimensionsDesktopImage;
    $[15] = dimensionsMobileImage;
    $[16] = goToNextDimensionShot;
    $[17] = goToPreviousDimensionShot;
    $[18] = hasCylindoDimensionShots;
    $[19] = hasMultipleDimensionShots;
    $[20] = loading;
    $[21] = onImageClick;
    $[22] = selectedDimensionShotIndex;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== dimensions || $[25] !== loading) {
    t15 = <div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={dimensions} loading={loading} /></div>;
    $[24] = dimensions;
    $[25] = loading;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== boxDimensions || $[28] !== loading) {
    t16 = boxDimensions?.length > 0 && <div className="[border-top:1px_solid_#e5e5e5] mt-14 pt-14 [content-visibility:auto] [contain-intrinsic-size:0]"><div className="max-w-[480px] mx-auto my-0"><h2 className="text-xl font-bold text-gray">{loading ? <Placeholder type="rect" loading={true} style={{
            height: "28px",
            width: "220px"
          }} /> : "Shipping Dimensions"}</h2></div><div className="max-w-[480px] mx-auto my-0"><PDPInfoTable items={boxDimensions} loading={loading} /></div></div>;
    $[27] = boxDimensions;
    $[28] = loading;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t16) {
    t17 = <div className="PDPDimensionsContentUI">{t13}{t14}{t15}{t16}</div>;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  return t17;
};
PDPDimensionsContentUI.propTypes = {
  dimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  boxDimensions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })),
  dimensionsDesktopImage: PropTypes.string,
  dimensionsMobileImage: PropTypes.string,
  loading: PropTypes.bool,
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  hasCylindoDimensionShots: PropTypes.bool,
  dimensionShotUrls: PropTypes.arrayOf(PropTypes.object),
  currentDimensionShot: PropTypes.shape({
    src: PropTypes.string.isRequired,
    dimensionCode: PropTypes.string.isRequired
  }),
  hasMultipleDimensionShots: PropTypes.bool,
  selectedDimensionShotIndex: PropTypes.number,
  goToNextDimensionShot: PropTypes.func,
  goToPreviousDimensionShot: PropTypes.func
};
export default PDPDimensionsContentUI;